#import "./flexibleRichtext.graphql"
#import "./flexibleImage.graphql"
#import "./flexibleVideo.graphql"
#import "./flexibleButton.graphql"
#import "./flexibleTeamMembers.graphql"
#import "./flexibleDeadlines.graphql"
#import "./flexibleHelpCards.graphql"

fragment flexibleSectionsBigAccordionSections on flexibleSections_NeoField {
    __typename
    ... flexibleRichtext
    ... flexibleImage
    ... flexibleVideo
    ... flexibleButton
    ... flexibleTeamMembers
    ... flexibleDeadlines
    ... flexibleHelpCards
}
